var config = {

  //开发
  // apiUrl: 'https://ssx.fzjiading.com/bxapi',
  // imgUrl: 'https://ssx.fzjiading.com/bxapi',
  // fileUpload: 'https://ssx.fzjiading.com/bxapi/upload/fileupload1', //文件上传
  // fileUrl2: 'https://ssx.fzjiading.com/bxapi/upload/fileupload3?callBackPath=https://ssx.fzjiading.com/bxback/index.html',  //富文本上传使用
  //

  // apiUrl: 'http://192.168.110.176:8196',
  // imgUrl: 'http://192.168.110.176:8196',
  // fileUpload: 'http://192.168.110.176:8196/upload/fileupload1', //文件上传
  // fileUrl2: 'http://192.168.110.176:8196/upload/fileupload3?callBackPath=http://192.168.110.176:8090/index.html',  //富文本上传使用

  //开发
  apiUrl: 'https://www.cirgou.com/api',
  imgUrl: 'https://www.cirgou.com/api',
  fileUpload: 'https://www.cirgou.com/api/upload/fileupload1', //文件上传
  fileUrl2: 'https://www.cirgou.com/api/upload/fileupload3?callBackPath=https://www.cirgou.com/index.html',  //富文本上传使用
  imagePath : 'https://www.cirgou.com/staticfile/',

  //虚拟机正式s
  // apiUrl: 'http://10.140.56.45:8100/api/',
  // fileUpload: 'http://10.140.56.45:8100/api/upload/fileupload1', //文件上传
  // fileUrl2: 'http://10.140.56.45:8100/api/upload/fileupload3?callBackPath=http://10.140.56.45:8100/index.html',  //富文本上传使用




};
export default config;



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 4